module.exports = __webpack_public_path__ + "static/media/icon-correct.ee745443.svg";